export var checkInSklandApp = function () {
    return navigator.userAgent.toLowerCase().includes('skland');
};
